module.exports = __webpack_public_path__ + "img/甄利凯.4fd4a7f0.jpg";